import { getWeb3Async } from './web3'
import { waitTxFromMetamask } from '../utils/blockchain'
import {
  BLOCKCHAIN_BINANCE,
  WEB3_PROVIDER_METAMASK,
} from '../constants/blockchain'
import { signAndSend } from './transaction'

let contract = null
let artifacts = null

export async function getArtifactsAsync () {
  if (!artifacts) {
    /* eslint-disable-next-line no-alert */
    artifacts = await import(/* webpackChunkName: 'timebridge-sc-artifacts' */ '@chronotech/cgu.artifacts/cgu.locker.json')
  }
  return artifacts
}

export async function getContractAsync () {
  const web3 = await getWeb3Async({ blockchain: BLOCKCHAIN_BINANCE })
  artifacts = await getArtifactsAsync()
  if (!contract) {
    contract = new web3.eth.Contract(artifacts.abi, artifacts.networks[BLOCKCHAIN_BINANCE].address)
  }
  return contract
}

export async function withdrawAvailableTokens (
  {
    wallet = WEB3_PROVIDER_METAMASK,
    from,
  },
) {
  const contract_ = await getContractAsync({})
  const encodedAbi = contract_.methods.withdrawAvailableTokens().encodeABI()
  const eventEmitter = await signAndSend({
    wallet,
    from,
    to: contract_.options.address,
    encodedAbi,
  })
  return waitTxFromMetamask(eventEmitter)
}

export async function timeLocksLength (from) {
  const contract_ = await getContractAsync({})
  const count = await contract_.methods.timeLocksLength(from).call()
  return count
}

export async function timeSmoothLocksLength (from) {
  const contract_ = await getContractAsync({})
  const count = await contract_.methods.timeSmoothLocksLength(from).call()
  return count
}

export async function timeLock (from, index) {
  const contract_ = await getContractAsync({})
  const res = await contract_.methods.timeLocks(from, index).call()
  return res
}

export async function timeSmoothLock (from, index) {
  const contract_ = await getContractAsync({})
  const res = await contract_.methods.timeSmoothLocks(from, index).call()
  return res
}

export async function getAmounts (from) {
  const contract_ = await getContractAsync({})
  const res = await contract_.methods.getAmounts(from).call()
  return res
}
